import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone } from 'lucide-react';
import { Button } from './ui/button';
import { brandLogo } from '../data/mock';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'Menu', path: '/menu' },
    { name: 'About', path: '/about' },
    { name: 'Locations', path: '/locations' },
    { name: 'Franchise', path: '/franchise' },
    { name: 'Contact', path: '/contact' }
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header className="sticky top-0 z-50 bg-gradient-to-r from-yellow-400 to-yellow-500 border-b-2 border-yellow-600 shadow-lg">
      <nav className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-2">
            <img 
              src={brandLogo} 
              alt="देशी STUFF Logo" 
              className="h-16 w-auto"
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`font-bold text-base transition-all duration-200 ${
                  isActive(link.path)
                    ? 'text-black border-b-2 border-black'
                    : 'text-gray-800 hover:text-black'
                }`}
              >
                {link.name}
              </Link>
            ))}
          </div>

          {/* CTA Buttons */}
          <div className="hidden md:flex items-center space-x-4">
            <a href="tel:9601382424">
              <Button variant="outline" className="font-bold border-2 border-black text-black hover:bg-black hover:text-yellow-400">
                <Phone className="w-4 h-4 mr-2" />
                Call Now
              </Button>
            </a>
            <a href="https://wa.me/919601382424" target="_blank" rel="noopener noreferrer">
              <Button className="font-bold bg-black hover:bg-gray-900 text-yellow-400">
                Order Now
              </Button>
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden text-black hover:text-gray-800 transition-colors"
          >
            {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden mt-4 pb-4 border-t-2 border-yellow-600 pt-4">
            <div className="flex flex-col space-y-4">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  onClick={() => setIsMenuOpen(false)}
                  className={`font-bold text-base transition-colors ${
                    isActive(link.path)
                      ? 'text-black'
                      : 'text-gray-800 hover:text-black'
                  }`}
                >
                  {link.name}
                </Link>
              ))}
              <a href="tel:9601382424">
                <Button variant="outline" className="w-full font-bold border-2 border-black text-black hover:bg-black hover:text-yellow-400">
                  <Phone className="w-4 h-4 mr-2" />
                  Call Now
                </Button>
              </a>
              <a href="https://wa.me/919601382424" target="_blank" rel="noopener noreferrer">
                <Button className="w-full font-bold bg-black hover:bg-gray-900 text-yellow-400">
                  Order Now
                </Button>
              </a>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
};

export default Header;
